import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmPrimaryData, setFootprintingFarmPrimaryDataAdmin } from "services";

import { footprintingFarmPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_FARM_PRIMARY_DATA } from "consts";

import { FootprintingFarmPrimaryData } from "models";

export interface CreateFarmPrimaryDataQueryParams {
  autofillYear?: number;
}

export const useMutateFootprintingFarmPrimaryData = (
  farmId: string,
  year: number,
  payload: Omit<FootprintingFarmPrimaryData, "id">,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: (qps?: CreateFarmPrimaryDataQueryParams) =>
        isAdmin
          ? setFootprintingFarmPrimaryDataAdmin(payload, primaryDataId ?? "")
          : qps?.autofillYear
          ? setFootprintingFarmPrimaryData(payload, primaryDataId ?? "", { autofillYear: qps.autofillYear })
          : setFootprintingFarmPrimaryData(payload, primaryDataId ?? ""),
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "farm", farmId, year], true);
        }
        invalidateAndRefecthQueries(queryClient, footprintingFarmPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin));
      },
    },
    queryClient
  );
};
